import type { components } from "@erp/api-client";

export type Branch = components["schemas"]["Branch"];

export const MOCK_COMPANY_ID = "019132aa-0000-7000-8000-000000000001";

const NOW = "2026-08-01T08:00:00Z";
const branchId = (n: number): string => `019132aa-0000-7000-8000-${String(n).padStart(12, "0")}`;

/**
 * Shared, read-only branch master data. Keep this fixture independent from
 * ledger data so the application shell can bootstrap before Finance loads.
 */
export const BRANCHES: Branch[] = [
  {
    id: branchId(700001),
    company_id: MOCK_COMPANY_ID,
    code: "B01",
    name: "Riyadh HQ",
    name_ar: "الرياض — المركز الرئيسي",
    address_line1: "King Fahd Road",
    address_line2: null,
    city: "Riyadh",
    region: "Riyadh",
    postal_code: "12271",
    country_code: "SA",
    status: "active",
    version: 1,
    created_at: NOW,
    updated_at: NOW,
  },
  {
    id: branchId(700002),
    company_id: MOCK_COMPANY_ID,
    code: "B02",
    name: "Jeddah",
    name_ar: "جدة",
    address_line1: "Prince Sultan Road",
    address_line2: null,
    city: "Jeddah",
    region: "Makkah",
    postal_code: "23435",
    country_code: "SA",
    status: "active",
    version: 1,
    created_at: NOW,
    updated_at: NOW,
  },
  {
    id: branchId(700003),
    company_id: MOCK_COMPANY_ID,
    code: "B03",
    name: "Dammam archive",
    name_ar: "أرشيف الدمام",
    address_line1: "Dhahran Street",
    address_line2: null,
    city: "Dammam",
    region: "Eastern Province",
    postal_code: "32241",
    country_code: "SA",
    status: "inactive",
    version: 2,
    created_at: NOW,
    updated_at: "2026-08-02T08:00:00Z",
  },
];

export function branchByCode(code: string): Branch {
  const found = BRANCHES.find((branch) => branch.code === code);
  if (!found) throw new Error(`branches fixture: no branch ${code}`);
  return found;
}
